import { AlertSeverityEnum } from '@/shared/interfaces/erp/global/errors.interface';
import { DataAlertBitacora } from '@/shared/interfaces/erp/bitacora.interface';
import { toast } from 'react-toastify';
import { create } from 'zustand';

const CustomToast = ({ title, subtitle }: { title: string; subtitle: string }) => (
  <div>
    <h4 style={{ margin: '0', fontWeight: 'bold' }}>{title}</h4>
    <p style={{ margin: '0' }}>{subtitle}</p>
  </div>
);

interface useBitacoraStoreProps {
  setAlert: (message: DataAlertBitacora, severity: AlertSeverityEnum | string) => void;
}

export const useUitsTsxStore = create<useBitacoraStoreProps>(() => ({

  setAlert: (message, severity) => {

    switch (severity) {
      case AlertSeverityEnum.info:
        toast.info(
          <div
          /* onClick={() => {
            if (message.room) {
              setModalBitactora(true)
              setBitacoraProps({
                canalVentaCreate: 'ss',
                contactName: 'sdsda',
                from: message.to,
                idAgendamiento: message.room,
                identificacion: '1233',
                razonSocial: 'admin',
                to: message.from
              })
            }
            console.log(message.room);
          }} */
          >
            <h4 style={{ margin: '0', fontWeight: 'bold' }}>Bitacora</h4>
            <p style={{ margin: '0' }}>{message.content}</p>
          </div>, {
        });
        break;
      case AlertSeverityEnum.error:
        toast.error(<CustomToast title={'Nuevo mensaje'} subtitle={message.content} />);
        break;
      case AlertSeverityEnum.success:
        toast.success(<CustomToast title={'Nuevo mensaje'} subtitle={message.content} />);
        break;
      case AlertSeverityEnum.warning:
        toast.warning(<CustomToast title={'Nuevo mensaje'} subtitle={message.content} />);
        break;
      default:
        break;
    }

  }


}));
